import { combineReducers } from "redux";

import { resetState } from "./initialState";
import currentFoodCourt from "./reducers/currentFoodCourt";
import currentFoodCourtDetails from "./reducers/currentFoodCourtDetails";
import currentRestaurantDetails from "./reducers/currentRestaurantDetails";
import foodCourtsList from "./reducers/foodCourtsList";
import foodCourtSettings from "./reducers/foodCourtSettings";
import userDetails from "./reducers/userDetails";
import errorMessage from "./reducers/errorMessage";
import snackbarMessage from "./reducers/snackbarMessage";
import menuList from "./reducers/menuList";
import immutableMenuList from "./reducers/immutableMenuList";
import immutableSubMenu from "./reducers/immutableSubMenu";
import cartItems from "./reducers/cartItems";
import filters from "./reducers/filters";
import searchText from "./reducers/searchText";
import paymentOptions from "./reducers/paymentOptions";
import selectedDate from "./reducers/selectedDate";
import currentSession from "./reducers/currentSession";
import immutableFilterList from "./reducers/immutableFilterList";
import successOrderID from "./reducers/successOrderID";
import firebaseDetails from "./reducers/firebaseDetails";
import addToHomeScreen from "./reducers/addToHomeScreen";
import restaurantsList from "./reducers/restaurantsList";
import immutableMultiSubMenu from "./reducers/immutableMultiSubMenu";
import multiRestaurantDetails from "./reducers/multiRestaurantDetails";
import tempCart from "./reducers/tempCart";
import saveFoodNRecURLS from "./reducers/saveFoodNRecURLS";
import setFirebaseStaticData from "./reducers/setFirebaseStaticData";
import forceTrigger from "./reducers/forceTrigger";
import allergens from "./reducers/allergens";
import immutableAllergens from "./reducers/immutableAllergens";
import searchNotify from "./reducers/searchNotify";
import searchData from "./reducers/searchData";
import { searchDataLoading } from "./reducers/searchDataLoading";
import { cafePassReducer } from "./reducers/cafePass";
import slotReducer from "./reducers/slotReducer";
import { slotDisplay } from "./reducers/slotDisplay";
import preorderData from "./reducers/preorderRedcuer";
import sessionsData from "./reducers/sessionsData";

// const appReducer = combineReducers({
//   currentFoodCourt,
//   currentFoodCourtDetails,
//   currentRestaurantDetails,
//   foodCourtsList,
//   foodCourtSettings,
//   userDetails,
//   errorMessage,
//   snackbarMessage,
//   immutableMenuList,
//   immutableSubMenu,
//   menuList,
//   cartItems,
//   filters,
//   searchText,
//   paymentOptions,
//   selectedDate,
//   currentSession,
//   immutableFilterList,
//   successOrderID,
//   firebaseDetails,
//   addToHomeScreen,
//   restaurantsList,
//   immutableMultiSubMenu,
//   multiRestaurantDetails,
//   tempCart,
//   foodNRecURLS: saveFoodNRecURLS,
//   firebaseStaticData: setFirebaseStaticData,
//   forceTrigger,
//   immutableAllergens,
//   allergens,
//   searchId: searchNotify,
//   searchData,
//   searchDataLoading,
//   cafePass: cafePassReducer,
//   slotShow: slotReducer
// });

const appReducer = (state = {}, action = "") => {
  const cafePass = state.cafePass;
  const storePreOrderData = state.preorderData;
  const storeSessionsData = state.sessionsData;
  return {
    currentFoodCourt: currentFoodCourt(state.currentFoodCourt, action),
    currentFoodCourtDetails: currentFoodCourtDetails(
      state.currentFoodCourtDetails,
      action
    ),
    currentRestaurantDetails: currentRestaurantDetails(
      state.currentRestaurantDetails,
      action
    ),
    foodCourtsList: foodCourtsList(state.foodCourtsList, action),
    foodCourtSettings: foodCourtSettings(state.foodCourtSettings, action),

    userDetails: userDetails(state.userDetails, action),
    errorMessage: errorMessage(state.errorMessage, action),
    snackbarMessage: snackbarMessage(state.snackbarMessage, action),
    immutableMenuList: immutableMenuList(state.immutableMenuList, action),
    immutableSubMenu: immutableSubMenu(state.immutableSubMenu, action),
    menuList: menuList(state.menuList, {
      ...action,
      cafePass,
      storePreOrderData,
      storeSessionsData
    }),
    cartItems: cartItems(state.cartItems, action),
    filters: filters(state.filters, action),
    searchText: searchText(state.searchText, action),
    paymentOptions: paymentOptions(state.paymentOptions, action),
    selectedDate: selectedDate(state.selectedDate, action),

    currentSession: currentSession(state.currentSession, action),
    immutableFilterList: immutableFilterList(state.immutableFilterList, action),
    successOrderID: successOrderID(state.successOrderID, action),
    firebaseDetails: firebaseDetails(state.firebaseDetails, action),
    addToHomeScreen: addToHomeScreen(state.addToHomeScreen, action),
    restaurantsList: restaurantsList(state.restaurantsList, action),
    immutableMultiSubMenu: immutableMultiSubMenu(
      state.immutableMultiSubMenu,
      action
    ),
    multiRestaurantDetails: multiRestaurantDetails(
      state.multiRestaurantDetails,
      action
    ),
    tempCart: tempCart(state.tempCart, action),

    foodNRecURLS: saveFoodNRecURLS(state.foodNRecURLS, action),
    firebaseStaticData: setFirebaseStaticData(state.firebaseStaticData, action),
    forceTrigger: forceTrigger(state.forceTrigger, action),
    immutableAllergens: immutableAllergens(state.immutableAllergens, action),
    allergens: allergens(state.allergens, action),

    searchId: searchNotify(state.searchId, action),
    searchData: searchData(state.searchData, action),
    searchDataLoading: searchDataLoading(state.searchDataLoading, action),
    cafePass: cafePassReducer(state.cafePass, action),
    slotShow: slotReducer(state.slotShow, action),
    slotDisplay: slotDisplay(state.slotDisplay, action),
    preorderData: preorderData(state.preorderData, action),
    sessionsData: sessionsData(state.sessionsData, action)
  };
};

const rootReducer = (state, action) => {
  if (action.type === "PURGE_EVERYTHING") {
    const storageData = JSON.parse(localStorage.getItem("state")) || {};
    localStorage.clear();
    state = resetState;
    // state["firebaseStaticData"] = storageData["firebaseStaticData"] || {};
  }

  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/rootReducer.js